"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUrlParts = getUrlParts;
exports.getMeetingLinkSlug = getMeetingLinkSlug;
exports.hasAnchorLink = hasAnchorLink;
exports.formatUserName = formatUserName;
exports.getAlphabeticalSortPrioritizingUser = exports.alphabeticalSort = exports.isMeetingLink = exports.getSetupMeetingLinkUrl = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

function trimLeadingSlash(string) {
  return string.split('/').splice(1).join('/');
}

function getUrlParts(href) {
  var anchor = document.createElement('a');
  anchor.href = href;
  return {
    domain: anchor.hostname,
    protocol: anchor.protocol,
    slug: trimLeadingSlash(anchor.pathname)
  };
}

function getMeetingLinkSlug(href) {
  var _getUrlParts = getUrlParts(href),
      slug = _getUrlParts.slug;

  var match = /^meetings\/(.+)/.exec(slug);

  if (match && match[1]) {
    slug = encodeURIComponent(match[1]);
  }

  return slug;
}

function hasAnchorLink(href) {
  return href.indexOf('#') > -1;
}

function formatUserName(user) {
  var firstName = user.firstName,
      lastName = user.lastName,
      email = user.email;

  if (firstName || lastName) {
    return ((firstName || '') + " " + (lastName || '')).trim();
  }

  return email;
}

var getSetupMeetingLinkUrl = function getSetupMeetingLinkUrl() {
  return "https://app.hubspot" + (_enviro.default.isQa() ? 'qa' : '') + ".com/settings/" + _hubspot.default.get() + "/sales/meetings/integration";
};

exports.getSetupMeetingLinkUrl = getSetupMeetingLinkUrl;

var isMeetingLink = function isMeetingLink(href) {
  var _getUrlParts2 = getUrlParts(href),
      slug = _getUrlParts2.slug;

  return slug.startsWith('meetings/');
};

exports.isMeetingLink = isMeetingLink;

var alphabeticalSort = function alphabeticalSort(a, b) {
  if (a.text < b.text) return -1;else if (a.text > b.text) return 1;else return 0;
};

exports.alphabeticalSort = alphabeticalSort;

var getAlphabeticalSortPrioritizingUser = function getAlphabeticalSortPrioritizingUser(userId) {
  return function (a, b) {
    if (a.userId === userId) return -1;else if (b.userId === userId) return 1;else return alphabeticalSort(a, b);
  };
};

exports.getAlphabeticalSortPrioritizingUser = getAlphabeticalSortPrioritizingUser;